import client from "../server/Client";
import {useQuery} from "@tanstack/react-query";

const categories = () => client.get('forms/categories');
export const useCategories = () => useQuery(['categories'], categories, {select: data => data?.data?.result})